import React, { Component, Fragment } from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import Image from '../../../config/images/gambar';
import { Link } from 'react-router-dom';
import { Capitalize } from '../../../config/utils';
import DateIndo from '../../../config/dateIndo';
import { getUser,getBatalMk } from '../../../services/api-services/batalmk-api';
import { getSemester } from '../../../services/api-services/filterdropdown';

var nowDate = new Date();
var tanggal = DateIndo(nowDate)

class HistoryBatal extends Component {

    state = {
        ttd: "",
        user: {
            angkatan: '',
            jurusan: '',
            kdjur: '',
            kurikulum: '',
            nama: '',
            nim: '',
            semester: '',
            smtta: '',
            ta: '',
        },
        OptSemester: [],
        listPengajuan: {
            data: []
        },
        isLoading: false,
        selectedSemester: '-'
    }

    getAllData = async () => {
        const { nim } = this.props.location.state
        const allPromise = Promise.all([
            getUser(nim),
            getSemester(nim)
        ])
        const promises = await allPromise
        this.setState({
            user: promises[0].data,
            listSemester: promises[1].data,
            ttd: promises[0].data.dosenwali
        })
    }

    getAllData = async () => {
        const nim = localStorage.getItem('nim');

        const allPromise = Promise.all([
            getUser(nim),
            getSemester(nim)
        ])

        const promises = await allPromise

        this.setState({
            user: promises[0].data,
            OptSemester: promises[1].data
        })
    }

    getHistoryPengajuan = async (e) => {
        const nim = localStorage.getItem('nim');
        this.setState({ isLoading: true })

        const response = await getBatalMk(nim, e.target.value)
        this.setState({
            listPengajuan: response.data,
            selectedSemester: e.target.value,
            isLoading: false
        })
    }

    componentDidMount = () => {
        this.getAllData();
    };

    render() {

        const { OptSemester, isLoading} = this.state
        const { angkatan, nama, nim } = this.state.user
        const { data} = this.state.listPengajuan

        const statusTheme = (val) => {
            if (val === 'Disetujui') return 'success'
            else if (val === 'Ditolak') return 'danger'
            else return 'primary'
        }

        const tableAddOns = (val) => {
            return (
                <tr>
                    <td className='text-center' colSpan={9}>
                        {
                            val === 'loading' ?
                                <div id="spinner" className="loader-1 colorful mt-5 mb-5">
                                    <div className="dot" />
                                    <div className="dot" />
                                    <div className="dot" />
                                </div>
                                : '-- Tidak Ada Data --'
                        }
                    </td>
                </tr>
            )
        }

        return (
            <Fragment>
                <div className="smooth mb-2">
                    <div className="col-md-12 mb-3">
                        <div className="row">
                            <div className="col-12 col-xl-8 mb-xl-0">
                                <p className="abu" style={{ fontSize: "15px", fontWeight: "bold", color: "#999999", textTransform: "capitalize" }}>
                                    Akademik&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;History Batal MK
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="card card-custom">
                        <div className="card-body">
                            <p className="card-title text-center" style={{ fontSize: "25px", marginTop: "10px", marginBottom: "35px" }}>
                                Batal Matakuliah
                            </p>
                            <div className="table-responsive pl-2 pr-2">
                                <table className="display expandable-table tableBord table-striped" style={{ width: "100%" }}>
                                    <thead></thead>
                                    <tbody>
                                        <tr>
                                            <td>NIM</td>
                                            <td> : </td>
                                            <td>{nim}</td>

                                            <td>Angkatan</td>
                                            <td> : </td>
                                            <td>{angkatan}</td>
                                        </tr>
                                        <tr>
                                            <td>Nama</td>
                                            <td> : </td>
                                            <td>{nama}</td>

                                            <td>Semester</td>
                                            <td> : </td>
                                            <td>
                                                <select onChange={this.getHistoryPengajuan} className="form-control custom-width">
                                                    <option value="" hidden>- Pilih Semester -</option>
                                                    {
                                                        OptSemester.map((v, index) => {
                                                            return (
                                                                <option key={index} value={v.semester}>{'Semester ' + v.semester}</option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <br />
                            <br />
                            <p className="card-title" style={{ fontSize: "17px", marginLeft: "10px" }}>
                              History Batal MK :
                            </p>
                            <div className="table-responsive">
                                <table width="100%" align="center" className="display expandable-table table-bordered table-radius"
                                >
                                    <thead>
                                        <tr align="center">
                                            <th style={{ borderRadius: '0px' }}>No</th>
                                            <th>Kode MK</th>
                                            <th>Mata Kuliah</th>
                                            <th>Dosen Pengajar</th>
                                            <th>SKS Teori</th>
                                            <th>SKS Praktek</th>
                                            <th>Status</th>
                                            <th>Keterangan</th> 
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            !isLoading ?
                                                data.length !== 0 ?
                                                    data.map((v, index) => {
                                                        return (
                                                            <tr height={10} key={index}>
                                                                <td align="center">{index + 1}</td>
                                                                <td align="center">
                                                                    <button type="button"
                                                                        title="detail nilai mk"
                                                                        className="btn btn-primary btn-sm btn-nilai" data-toggle="modal" data-target="#nilai">
                                                                        {v.kodemk}
                                                                    </button>
                                                                </td>   
                                                                <td>{v.matkul}</td>
                                                                <td align="center">{v.dosen}</td>
                                                                <td align="center">{v.skstoeri}</td>
                                                                <td align="center">{v.skspraktek}</td>
                                                                <td align="center"><span className={`badge badge-${statusTheme(v.status)}`} style={{ fontSize: '14px' }}>{v.status}</span></td>
                                                                <td align="center">{v.alasan}</td>
                                                            </tr>
                                                        )
                                                    })
                                                    : <> {tableAddOns('null')} </>
                                                : <> {tableAddOns('loading')} </>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment >
        );
    }
}

export default HistoryBatal;